import { render, staticRenderFns } from "./SimulationsListView.vue?vue&type=template&id=72d04876&"
import script from "./SimulationsListView.vue?vue&type=script&lang=js&"
export * from "./SimulationsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports